import { render, staticRenderFns } from "./IconSetDelivery.vue?vue&type=template&id=33b95728&scoped=true&"
import script from "./IconSetDelivery.vue?vue&type=script&lang=js&"
export * from "./IconSetDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b95728",
  null
  
)

export default component.exports